import { Toaster as UiToaster } from '@eazydraft/ui';
import type { ComponentProps } from 'react';

import { useThemeStore } from '@/utils/stores/useThemeStore';

/**
 * Toaster bound to the resolved app theme. sonner defaults to its own
 * `prefers-color-scheme` detection, which can disagree with the Outlook host
 * theme driving the rest of the UI.
 */
export function Toaster(props: ComponentProps<typeof UiToaster>) {
  const theme = useThemeStore((state) => state.theme);
  return <UiToaster theme={theme} {...props} />;
}
